// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__mzp1J","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__KyuBD"};